<div class="heatmap-editor symbol-editor" *ngIf="heatmapRenderer">
    <mc-slider field="Pixel Intensity"
               gap="10"
               max="500"
               [maxValue]="heatmapRenderer.maxPixelIntensity"
               min="0"
               [minValue]="heatmapRenderer.minPixelIntensity"
               mode="multiple"
               step="10"
               (valueChange)="onPixelIntensityChange($event)">
    </mc-slider>
    <div class="clearfix legendWideControlGroup">
        <label>Blur Radius:</label>
        <input class="form-control" type="number" [(ngModel)]="blurRadius" max="100" min="0" step="1" />
    </div>
    <div class="clearfix legendWideControlGroup">
        <label>Colors: </label>
        <mc-color-picker-ng #colorPicker
                            class="color-swatch left"
                            [color]="startColorRamp"
                            (colorChange)="updateColorFromPicker($event, '1')">
        </mc-color-picker-ng>
        <div #canvas class="canvas"></div>
        <mc-color-picker-ng #colorPicker
                            class="color-swatch right"
                            [color]="endColorRamp"
                            (colorChange)="updateColorFromPicker($event, '2')">
        </mc-color-picker-ng>
    </div>
    <div class="clearfix legendWideControlGroup">
        <label>Heatmap Mode</label>
        <fieldset class="radio-group">
            <input class="radio-group-input" type="radio" [id]="'off'" name="off" value="off" [(ngModel)]="heatmapMode" (ngModelChange)="onHeatmapModeChange()" />
            <label class="radio-group-label" [for]="'off'">Off</label>
            <input class="radio-group-input" type="radio" [id]="'on'" name="on" value="on" [(ngModel)]="heatmapMode" (ngModelChange)="onHeatmapModeChange()" />
            <label class="radio-group-label" [for]="'on'">On</label>
            <input class="radio-group-input" type="radio" [id]="'auto'" name="auto" value="auto" [(ngModel)]="heatmapMode" (ngModelChange)="onHeatmapModeChange()" />
            <label class="radio-group-label" [for]="'auto'">Auto</label>
        </fieldset>
    </div>
</div>
